import { Component } from '@angular/core';

@Component({
  selector: 'app-info-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './info-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class InfoIconComponent {}
